// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vehicle-item_wrapper__1z_3k","name":"vehicle-item_name__tvLMV","detail":"vehicle-item_detail__8V7mc"};